import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const SchoolSession = lazy(() => import('../pages/school-session/page'));
const Volunteer = lazy(() => import('../pages/volunteer/page'));
const RegisterRegular = lazy(() => import('../pages/register/regular/page'));
const RegisterVIP = lazy(() => import('../pages/register/vip/page'));
const RegisterTable = lazy(() => import('../pages/register/table/page'));
const RegisterSponsor = lazy(() => import('../pages/register/sponsor/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/school-session',
    element: <SchoolSession />,
  },
  {
    path: '/volunteer',
    element: <Volunteer />,
  },
  {
    path: '/register/regular',
    element: <RegisterRegular />,
  },
  {
    path: '/register/vip',
    element: <RegisterVIP />,
  },
  {
    path: '/register/table',
    element: <RegisterTable />,
  },
  {
    path: '/register/sponsor',
    element: <RegisterSponsor />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
